import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPostOffices } from '../../actions/postOfficeActions';
import { getCurrentLangPretty } from '../../helpers/url/urlHelpers';

const usePostOffices = () => {
	const lang = getCurrentLangPretty();
	const dispatch = useDispatch<any>();
	const { postOffices, postOfficesError, postOfficesLoading } = useSelector(
		({ postOfficeReducer }) => postOfficeReducer
	);

	useEffect(() => {
		if (postOffices === null && !postOfficesError && !postOfficesLoading) {
			dispatch(fetchPostOffices(lang));
		}
	}, [postOffices, postOfficesError, postOfficesLoading, dispatch, lang]);

	return {
		postOffices,
		postOfficesError,
		postOfficesLoading,
	};
};

export default usePostOffices;
